import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// King Floyd's — Returning-customers (reorder) campaign (adc_knrzhtv7ux). Real
// spend, conversions, and reorder ad sales from
// ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS (complete months
// Jul 2025 – Jul 2026). Monthly series lives in realBrandData.ts.
export const campKfReorder: FaireAdCampaignEntity = {
  token: "camp_kf_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_king_floyds",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 200,
  startedRunningAt: "2025-07-19",
  segmentMetrics: {
    numReorderConversions: 6,
    salesDollars: 1804,
    totalAdsSpendDollars: 258,
    returnOnAdSpend: 6.99,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-19T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
